// 👥 Employés E4b — Section 8 : Avertissements (clé RBAC `avertissements`). EmployeeAvertissements est la seule surface
// d'édition dans la fiche (routes /avertissements-auto partagées avec /gestion-avertissements). L'ancien champ
// `employee.avertissements` (onglet « Mesures » retiré) reste visible en archive, lecture seule.
import { AlertTriangle } from 'lucide-react';
import { SectionFiche } from './SectionFiche';
import { EmployeeAvertissements } from '@/components/EmployeeAvertissements';

export function SectionAvertissements({ employee, peutGerer }) {
  const archive = employee.avertissements || [];
  return (
    <SectionFiche cle="avertissements" titre="Avertissements" icone={AlertTriangle}>
      <EmployeeAvertissements employeeId={employee.id} employeeNom={`${employee.prenom} ${employee.nom}`} canManage={peutGerer} />
      {archive.length > 0 && (
        <div className="mt-4 border-t pt-3" data-testid="avertissements-archive">
          <p className="text-xs text-slate-500 mb-1">Archive — mesures disciplinaires de l'ancien formulaire (lecture seule)</p>
          <ul className="space-y-1">
            {archive.map((m, i) => (
              <li key={m.id || m._id || i} className="text-sm bg-slate-50 rounded px-3 py-1.5"><span className="font-medium">{m.type || m.titre || 'Mesure'}</span> <span className="text-xs text-slate-500">{m.date}</span>{m.description && <p className="text-xs text-slate-600">{m.description}</p>}</li>
            ))}
          </ul>
        </div>
      )}
    </SectionFiche>
  );
}
